/**
 * Email formatting utility
 * Rules:
 * 1. Only one @ allowed
 * 2. Username (Before @): lowercase letters, numbers, . _ - ! & ' * + / = allowed
 * 3. Domain (After @, before '.') : only lowercase letters (no numbers)
 * 4. Top level domain (After '.'): at least 2 lowercase letters (TLD)
 */
export const formatEmail = (input: string): string => {
  let value = input.toLowerCase();

  // Handle the specific En-Dash (–) (e.g.copy from outlook) by converting it to a standard hyphen (-)
  value = value.replace(/\u2013|\u2014/g, '-');

  // Remove any typed backslashes
  value = value.replace(/\\/g, '');

  const atIndex = value.indexOf('@');

  const cleanLocalPart = (str: string): string => {
    return str.replace(/[^a-z0-9!&'*+/=_\\.-]/g, '');
  };

  const cleanDomainPart = (str: string): string => {
    return str
      .replace(/[^a-z0-9.-]/g, '')
      .replace(/\.\.+/g, '.')
      .replace(/--+/g, '-');
  };

  if (atIndex === -1) {
    return cleanLocalPart(value);
  }

  const localPart = cleanLocalPart(value.slice(0, atIndex));
  const domainPart = cleanDomainPart(value.slice(atIndex + 1));

  return localPart + '@' + domainPart;
};
